import { jsx as l, jsxs as Z } from "react/jsx-runtime";
import "react";
var i = (h) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...h,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#6DA544",
      d: "M33.995 5.714A19.933 19.933 0 0 0 20 0c-1.74 0-6.828 2.18-10.435 5.714h24.43ZM20 17.143h19.796a19.857 19.857 0 0 0-1.722-5.714H19.131L20 17.143ZM1.926 28.571h36.148a19.857 19.857 0 0 0 1.722-5.714H.204a19.854 19.854 0 0 0 1.722 5.714Zm4.079 5.715A19.933 19.933 0 0 0 20 40c5.449 0 10.388-2.18 13.995-5.714H6.005Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M20 0C9.925 0 1.59 7.45.204 17.143H20V0Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "m10 15.333-.87-1.739v-3.478l2.175-1.739 2.173 1.74v2.608l.87-.87v1.74l-1.74 1.738H10ZM5.323 10l.23.709h.745l-.602.438.23.708-.603-.438-.603.438.23-.708-.602-.438h.745l.23-.709Zm1.739-1.74.23.71h.746l-.603.438.23.708-.603-.438-.602.438.23-.708-.603-.439h.745l.23-.708Zm1.739-1.738.23.708h.746l-.603.438.23.709-.603-.438-.602.438.23-.709-.603-.438h.745l.23-.708ZM17.286 10l-.23.709h-.745l.602.438-.23.708.603-.438.602.438-.23-.708.603-.438h-.745l-.23-.709Zm-1.739-1.74-.23.71h-.746l.603.438-.23.708.603-.438.602.438-.23-.708.603-.439h-.745l-.23-.708Zm-1.74-1.738-.23.708h-.745l.603.438-.23.709.602-.438.603.438-.23-.709.603-.438h-.745l-.23-.708Zm-2.502-.87-.23.709h-.746l.603.438-.23.708.603-.438.602.438-.23-.708.603-.438h-.745l-.23-.709Z"
    })
  ]
});
export {
  i as default
};
